import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { CustomTranslationService } from '../../translation/custom-translation.service';
import {DateTimeHelper} from "../../helpers/datetime.helper";

@Component({
    selector: 'diana-date-picker',
    templateUrl: './date-picker.component.html',
    standalone: false
})
export class DatePickerComponent {
  constructor(
    private localService: BsLocaleService,
    private translationService: CustomTranslationService
  ) {
    this.translationService.currentLanguage$.subscribe(lang => {
      this.localService.use(lang.key);
      // workaround to refresh the datepicker
      this.initialDate = this.currentDate;
      this.currentDate = DateTimeHelper.copyDate(this.initialDate);
    });
  }

  @Input() initialDate = DateTimeHelper.now();
  @Input() maxDate: Date | undefined = undefined;

  currentDate = this.initialDate;

  @Output()
  dateSelected: EventEmitter<Date> = new EventEmitter();
  onValueChange(selectedDate: Date): void {
    if (selectedDate !== this.initialDate) {
      this.currentDate = selectedDate;
      this.dateSelected.emit(selectedDate);
    }
  }
}
